import type { RichTextElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { SlateElementType } from '@vedalib/rich-text'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './RichTextElement'
import type { RichTextDemoType } from './richTextTypes'

const DEMO_VALUE: RichTextElementValue = [
  {
    type: SlateElementType.heading1,
    children: [
      {
        text: t('elements.richText.value.h1'),
      },
    ],
  },
  {
    type: SlateElementType.heading2,
    children: [
      {
        text: t('elements.richText.value.h2'),
      },
    ],
  },
  {
    type: SlateElementType.heading3,
    children: [
      {
        text: t('elements.richText.value.h3'),
      },
    ],
  },
  {
    type: SlateElementType.elementDefault,
    children: [
      {
        text: t('elements.richText.value.default'),
      },
    ],
  },
]

const RichTextDemo: RichTextDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.richText.type}-demo`,
        type: CONFIG_ELEMENTS.richText.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default RichTextDemo
